export default __webpack_public_path__ + "static/media/waterfalls3.42887ef2.webp";